<template>
  <v-layout>
    <v-flex>
      <v-toolbar class="elevation-1">
        <v-btn small dark color="light-blue darken-3" @click="add_dialog.show = true">
          Добавить организацию
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title>
          <h3 class="title">Список организаций</h3>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="organizations"
                no-data-text="Организации отсутствуют"
                hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.edrpou }}</td>
            <td>{{ props.item.drfo }}</td>
            <td>
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click.stop="showDelete(props.item)" class="ma-0">
                  <v-icon small color="pink">
                    delete
                  </v-icon>
                </v-btn>
                <span>Удалить</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="add_dialog.show" persistent lazy max-width=500>
        <v-card>
          <v-card-title>
            <h3 class="title">Добавление новой организации</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="add_form" v-model="add_dialog.form.add_form_valid" lazy-validation>
              <v-text-field
                v-model="add_dialog.form.name"
                :error-messages="add_dialog.form.errors.name"
                :rules="add_dialog.form.nameRules"
                label="Название"></v-text-field>
              <v-text-field
                v-model="add_dialog.form.edrpou"
                :error-messages="add_dialog.form.errors.edrpou"
                :rules="add_dialog.form.edrpouRules"
                label="ЕДРПОУ"></v-text-field>
              <v-text-field
                v-model="add_dialog.form.drfo"
                :error-messages="add_dialog.form.errors.drfo"
                :rules="add_dialog.form.drfoRules"
                label="ДРФО"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="onCloseAddDialog()">
              Отмена
            </v-btn>
            <v-btn @click="submit()" :disabled="!add_dialog.form.add_form_valid" dark color="light-blue darken-3" :loading="add_dialog.form.loading">
              Добавить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="del_dialog.item" v-model="del_dialog.show" persistent lazy max-width="400">
        <v-card>
          <v-card-title class="title">Удалить организацию</v-card-title>
          <v-card-text>
            <b>Название:</b>&nbsp; {{ del_dialog.item.name }}<br>
            <b>ЕДРПОУ:</b>&nbsp; {{ del_dialog.item.edrpou }}<br>
            <b>ДРФО:</b>&nbsp; {{ del_dialog.item.drfo }}<br>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="del_dialog.show = false">Отмена</v-btn>
            <v-btn dark color="pink" @click.native="confirmDelete(del_dialog.item.id)">Удалить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'OrganizationList',
  data () {
    return {
      del_dialog: {
        show: false,
        item: null
      },
      add_dialog: {
        show: false,
        form: {
          add_form_valid: true,
          loading: false,
          name: null,
          edrpou: null,
          drfo: null,
          errors: {
            pkey: [],
            issuer: [],
            password: [],
          },
          nameRules: [v => !!v || 'Обязательное поле.'],
          edrpouRules: [this.checkEdrpou],
          drfoRules: [this.checkDrfo]
        }
      },
      headers: [
        {
          text: 'Название',
          value: 'name',
          sortable: false
        },
        {
          text: 'ЕДРПОУ',
          value: 'edrpou',
          sortable: false
        },
        {
          text: 'ДРФО',
          value: 'drfo',
          sortable: false
        },
        {
          text: 'Действия',
          value: 'name',
          sortable: false
        }
      ]
    }
  },
  methods: {
    async submit () {
      if (!this.$refs.add_form.validate()) {
        return
      }

      this.add_dialog.loading = true

      await this.$store.dispatch('postOrganization', {
        name: this.add_dialog.form.name,
        edrpou: this.add_dialog.form.edrpou,
        drfo: this.add_dialog.form.drfo || ''
      })

      this.add_dialog.loading = false
      this.onCloseAddDialog()

      await this.$store.dispatch('getOrganizationList')
    },
    onCloseAddDialog () {
      this.add_dialog.show = false
      this.$refs.add_form.reset()
    },
    showDelete (item) {
      this.del_dialog.item = item
      this.del_dialog.show = true
    },
    async confirmDelete (organization_id) {
      this.del_dialog.show = false
      await this.$store.dispatch('deleteOrganization', organization_id)
      await this.$store.dispatch('getOrganizationList')
    },
    checkEdrpou (value) {
      if (value === '')
        return 'Обязательное поле.'

      if (value && !value.match(/^[0-9]{8,10}$/y))
        return 'Неверный формат ЕДРПОУ. Ожидается 8-10 цифр.'

      return true
    },
    checkDrfo (value) {
      if (value && !value.match(/^[0-9]{10}$/y))
        return 'Неверный формат ДРФО. Ожидается 10 цифр.'

      return true
    }
  },
  computed: {
    ...mapState({
      organizations: state => state.organizations
    })
  },
  created () {
    this.$store.dispatch('getOrganizationList')
  }
}
</script>